import React from 'react';

const ShareText = ({ text }) => <p className="share-button__text">{text}</p>;

export default ShareText;
